// Library Import
import { useToast } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Local Imports
import { redResetError, redSetToastReset } from "../redux/slices/userSlice";
import { redResetAdminError } from "../redux/slices/adminSlice";

const Toasts = () => {
  const toast = useToast();
  const dispatch = useDispatch();

  const {
    userToast: { title, status },
  } = useSelector((state) => state.stateUserReducer);

  const { error } = useSelector((state) => state.stateUserReducer);

  useEffect(() => {
    if (title && status) {
      toast({
        title: title,
        status: status,
        duration: 5000,
        isClosable: true,
      });

      setTimeout(() => dispatch(redSetToastReset()), 2000);
    }

    if (error) {
      toast({
        title: error,
        status: "error",
        duration: 5000,
        isClosable: true,
      });

      setTimeout(() => dispatch(redResetError()), 500);
    }
  }, [title, status, error]);

  return <></>;
};

export default Toasts;
